import { render, staticRenderFns } from "./RegistrosAnterioresCollapse.vue?vue&type=template&id=fd85b320&scoped=true&"
import script from "./RegistrosAnterioresCollapse.vue?vue&type=script&lang=js&"
export * from "./RegistrosAnterioresCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd85b320",
  null
  
)

export default component.exports